<template>
  <Content :button-create-show="true" link="/users/create">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      />
    </template>
  </Content>
</template>

<script>
import Table from "@/components/Table";
import Content from "@/layout/Content";

import { getUsers as fetchData } from "@/api/users";

const columnsOptions = {
  sortable: true,
  itemsName: "items",
  controls: true,
  editable: true,
  id: "id",
  search_list: [
    { label: "Имя пользователя", name: "username" },
    {
      label: "Активен",
      name: "is_active",
      strong: true,
      values: [
        { label: "— Любой —", code: "" },
        { label: "Да", code: "true" },
        { label: "Нет", code: "false" },
      ],
    },
  ],
};

const columns = [
  { prop: "id", label: "ID", width: 50 },
  { prop: "username", label: "Имя пользователя" },
  { prop: "roles", label: "Роли", width: 180, type: "list" },
  { prop: "is_active", label: "Активен", type: "bool", width: 100 },
  { prop: "created_at", label: "Создан", type: "datetime", width: 180 },
  {
    prop: "last_login_at",
    label: "Последний вход",
    type: "datetime",
    width: 180,
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions,
      columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
